import { v4 as uuidv4 } from 'uuid';
import type { LinkType } from '../../../../../shared/types';
import { RedirectsClientOverride } from '../../../../../shared/types';
import type { IAdLinkTemplateRules } from '../../../../../shared/types/links/Interfaces/template/ad-link-template/IAdLinkTemplateRules';
import type { IQuickLinkTemplateRules } from '../../../../../shared/types/links/Interfaces/template/quick-link-template/IQuickLinkTemplateRules';
import { AGENCY_LINK_KEY } from '../../support/constants';
import { LinkTemplateFieldValueType } from '../../types/linkTypes';
import type { LinkDataObject } from '../../types/links/LinkDataObject.type';
import { LinkDataService } from '../LinkDataService';

type LinkTemplate = IAdLinkTemplateRules | IQuickLinkTemplateRules;

export enum Redirect {
  Default = 'default',
  Web = 'web',
  Deepview = 'deepview',
}

export class LinkAdapterService {
  constructor(
    private linkType: LinkType,
    private linkTemplate?: LinkTemplate
  ) {}

  getRedirectType(override?: RedirectsClientOverride) {
    switch (override) {
      case RedirectsClientOverride.Deepview: {
        return Redirect.Deepview;
      }
      case RedirectsClientOverride.WebUrl: {
        return Redirect.Web;
      }
      case RedirectsClientOverride.DefaultRedirect:
      default: {
        return Redirect.Default;
      }
    }
  }

  getLinkDataOptions(linkData: Record<string, any> = {}) {
    const templateLinkData = this.linkTemplate?.linkData || [];
    const linkDataWithoutPresets = LinkDataService.excludePresetsFromLinkCreatorData(linkData, this.linkType);

    const linkDataOptions: LinkDataObject[] = [];
    for (const [key, value] of Object.entries(linkDataWithoutPresets)) {
      if (key === AGENCY_LINK_KEY) {
        linkDataOptions.push({
          id: uuidv4(),
          key: { label: key, value: key },
          value: value,
          fixed: true,
          required: true,
        });
      } else {
        const template = (templateLinkData || []).find(({ fieldName }) => fieldName === key);

        let entryValue: string | undefined = value as string;
        if (template?.valueType === LinkTemplateFieldValueType.FIXED) {
          entryValue = template?.value as string;
        } else if (template?.valueType === LinkTemplateFieldValueType.EMPTY) {
          entryValue = undefined;
        }

        linkDataOptions.push({
          id: uuidv4(),
          key: { label: key, value: key },
          value: entryValue,
          choose: template?.valueType === LinkTemplateFieldValueType.CHOOSE,
          suggestions: template?.valueType === LinkTemplateFieldValueType.SUGGESTIONS,
          fixed: template?.valueType === LinkTemplateFieldValueType.FIXED,
          empty: template?.valueType === LinkTemplateFieldValueType.EMPTY,
          options: template?.value as string[],
          required: template?.required,
        });
      }
    }

    return linkDataOptions;
  }
}
